import { css } from '@emotion/core';
import { BrowserUtils } from '../../utils';

export const highContrastIconStyles = color => `
html body svg.vds-icon.vds-icon[class^="vds-icon"],
html body svg.vds-icon.vds-icon[class^="vds-icon"] use,
html body svg.vds-icon.vds-icon[class^="vds-icon"] use path {
  fill: ${color} !important;
  fill: windowText !important;
}
`;

export const globalStyles = css`
  .cybs-a11y-hidden {
    position: absolute;
    left: -100000px;
    top: 0;
    width: 0;
    height: 0;
    overflow: hidden;
  }

  .vds-dialog-curtain {
    opacity: 1 !important;
  }

  @media all and (-ms-high-contrast: active) {
    ${highContrastIconStyles('white')}
  }

  @media all and (-ms-high-contrast: black-on-white) {
    ${highContrastIconStyles('black')}
  }

  ${BrowserUtils.isHighContrastMode()
    ? highContrastIconStyles('white')
    : ''}
`;

export default globalStyles;
